import {ChangeDetectorRef, Component, effect, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {
  IonButton,
  IonCard,
  IonCol,
  IonContent,
  IonRow,
} from '@ionic/angular/standalone';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {components} from '../../configs/config';
import {LanguageService} from '../../core/language.service';
import {RegisterComponent} from '../register/register.component';
import {LoginComponent} from '../login/login.component';
import {ActivatedRoute} from '@angular/router';
import {LoginBannerComponent} from '../login-banner/login-banner.component';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['../../pages/contact/contact-form/contact-form.component.scss', './user-login.component.scss'],
  imports: [
    IonContent,
    IonRow,
    IonCol,
    FormsModule,
    ReactiveFormsModule,
    RegisterComponent,
    LoginComponent,
    IonCard,
    IonButton,
    LoginBannerComponent,
  ],
  host: { id: 'unique-id' }
})
export class UserLoginComponent  implements OnInit {

  formTextContent: any;
  languageService: LanguageService = inject(LanguageService);
  route: ActivatedRoute = inject(ActivatedRoute);
  cds: ChangeDetectorRef = inject(ChangeDetectorRef);
  platformId: Object = inject(PLATFORM_ID);
  formType: string = '';
  constructor() {
    effect(async () => {
      if (this.languageService.lang()) {
        this.formTextContent = await this.languageService.loadContent(components.forms);
      }
    });
  }

  ngOnInit() {
  }
  ionViewDidEnter() {
    this.route.params.subscribe(params => {
      console.log(params);
      setTimeout(() => {
        this.formType = params['type'];
        this.cds.detectChanges();
      });
    });
  }
  forgotPassword = false;
  isForgotPasswordEvent($event: any) {
    this.forgotPassword = $event;
  }

  goBack() {
    if (isPlatformBrowser(this.platformId)) {
      window.history.back();
    }
  }
}

